import React from "react";
import "./Gamecommon.css";
import GameHeroSection from "./GameHeroSection/GameHeroSection";
import GameCounter from "./gamecounter/GameCounter";
import GameIdeas from "./gameideas/GameIdeas";
import GameChoose from "./gamechoose/GameChoose";
import GameBuild from "./gamebuild/GameBuild";
import GameIndustry from "./gameindustry/GameIndustry";
import GameServices from "./gameservices/Services";

export default function GameDev() {
  return (
    <div>
      <GameHeroSection />
      <GameCounter/>
      <GameIdeas />
        <GameChoose />
        <GameBuild/>
     <GameIndustry/>
     <GameServices/>
    </div>
  );
}
